import { render, staticRenderFns } from "./buy.vue?vue&type=template&id=1c637d6d&scoped=true"
import script from "./buy.vue?vue&type=script&lang=js"
export * from "./buy.vue?vue&type=script&lang=js"
import style0 from "./buy.vue?vue&type=style&index=0&id=1c637d6d&prod&lang=less&scoped=true"
import style1 from "./buy.vue?vue&type=style&index=1&id=1c637d6d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c637d6d",
  null
  
)

export default component.exports